// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__37rPx","footer":"ModalCreateQualiphyProcedure_footer__3X-Ov","additionData":"ModalCreateQualiphyProcedure_additionData__bgmK2"};